export default "__VITE_ASSET__c1163c02__"